import { HTTP_CODE_UNAUTHORIZED } from './codes'

export const HTTP_ERROR_NAME = 'HttpError'
export const AUTHENTICATION_ERROR_NAME = 'AuthenticationError'

export class HttpError extends Error {
  public statusCode: number

  constructor(message: string, statusCode: number = 500) {
    super(message)
    this.name = HTTP_ERROR_NAME
    this.statusCode = statusCode
  }
}

export class AuthenticationError extends HttpError {
  constructor(message: string = 'Authentication required') {
    super(message, HTTP_CODE_UNAUTHORIZED)
    this.name = AUTHENTICATION_ERROR_NAME
  }
}
